import ArrayStore from "devextreme/data/array_store";

const createAgentObj = (data) => ({
  ...data,
  timeInCurrentState: "00m 00s",
  timestampPreviousState: new Date(data.timestampPreviousState),
  timestampCurrentState: new Date(data.timestampCurrentState),
  "": data.agentStateNum,
})

const createQueueObj = (data) => ({
  ...data,
  oldestCallInQueue: "00m 00s"
})

export default {
  state: () => ({
    agentData: new ArrayStore({
      key: "agentName",
      data: [],
    }),

    campaignData:  new ArrayStore({
      key: "campaignName",
      data: [],
    }),

    queueData: new ArrayStore({
      key: "queueNumber",
      data: [],
    }),
  }),

  mutations: {
    resetData: (state) => {
      state.agentData.clear();
      state.campaignData.clear();
      state.queueData.clear();
    },

    setCampaignData: (state, data) => {
      state.campaignData.clear();
      state.campaignData.push(data.map(x => ({
        type: "insert",
        key: x.campaignName,
        data: Object.freeze(x)
      })));
    },

    updateCampaignObject: (state, data) => {
      let op;
      const key = data.campaignName;
      state.campaignData.byKey(key).then(() => op = "update").catch(() => op = "insert")
      state.campaignData.push([{
        type: op,
        key: key,
        data: Object.freeze(data)
      }]);
    },

    setAgentData: (state, data) => {
      state.agentData.clear()
      state.agentData.push(data.map(x => ({
        type: "insert",
        key: x.agentName,
        data: Object.freeze(createAgentObj(x))
      })));
    },

    updateAgentObject: (state, data) => {
      if (data.agentName.includes("gdmsmonitor")) return;
      
      let op;
      const key = data.agentName;

      var agent = state.agentData.byKey(key);

      if (agent.state() == "rejected") {
        state.agentData.byKey(key).then(() => op = "update").catch(() => op = "insert")
        state.agentData.push([{
          type: op,
          key: key,
          data: Object.freeze(createAgentObj(data))
        }]);
      }
      else{
        state.agentData.byKey(key).then((item) => {
          if(data.agentStateNum == 7 && item.agentStateNum == 3)
          {
            console.log(data.agentName + ': ' + 'Previous: ' + item.agentState + '. New: ' + data.agentState);
          } 
          else{
            //console.log('Hello from else')
            state.agentData.byKey(key).then(() => op = "update").catch(() => op = "insert")
            state.agentData.push([{
              type: op,
              key: key,
              data: Object.freeze(createAgentObj(data))
            }]);
          }         
        });
      }
    },

    setQueueData: (state, data) => {
      state.queueData.clear();
      state.queueData.push(data.map(x => ({
        type: "insert",
        key: x.queueNumber,
        data: Object.freeze(createQueueObj(x))
      })));
    },

    updateQueueObject: (state, data) => {
      let op;
      const key = data.queueNumber;
      state.queueData.byKey(key).then(() => op = "update").catch(() => op = "insert")
      state.queueData.push([{
        type: op,
        key: key,
        data: Object.freeze(createQueueObj(data))
      }]);
    },
  },

  getters: {
    agentData: (state) => state.agentData._array,
    agentStore: (state) => state.agentData,
    campaignData: (state) => state.campaignData._array,
    campaignStore: (state) => state.campaignData,
    queueData: (state) => state.queueData._array,
    queueStore: (state) => state.queueData
  }
}